import React from "react"
import clsx from "clsx"
import ErrorHelper from "../../Errors/ErrorHelper"

export default class AccountBuilderGeneral extends React.Component {
  
  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.activeTab == 'general',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="general">
        {ErrorHelper.renderErrors(this.props.errors, ['name', 'url_display_name', 'booking_landing_page_url'])}
        <div className="row">
          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('name')}*</label>
              <input type="text" className={ErrorHelper.renderFieldClasses('name', this.props.errors, 'form-control')} name="name" value={this.props.name || ''} onChange={this.props.onChange} />
            </div>
            {ErrorHelper.renderFieldErrors('name', this.props.errors)}
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('email_domain')}* <span className="ss-help help" title={I18n.t('email_domain_helper_text')}></span></label>
              <input type="text" className={ErrorHelper.renderFieldClasses('email_domain', this.props.errors, 'form-control')} name="email_domain" value={this.props.email_domain || ''} onChange={this.props.onChange} />
            </div>
            {ErrorHelper.renderFieldErrors('email_domain', this.props.errors)}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group" style={{marginBottom: '0px'}}>
              <label>{I18n.t('url_display_name')} <span className="ss-help help" title={I18n.t('url_display_name_helper_text')}></span></label>
              <input type="text" className={ErrorHelper.renderFieldClasses('url_display_name', this.props.errors, 'form-control')} name="url_display_name" value={this.props.url_display_name || ''} onChange={this.props.onChange} />
            </div>
            {ErrorHelper.renderFieldErrors('url_display_name', this.props.errors)}
          </div>
          <div className="col-sm-6">
            <div className="form-group" style={{marginBottom: '0px'}}>
              <label>{I18n.t('booking_landing_page_url')} <span className="ss-help help" title={I18n.t('booking_landing_page_url_helper_text')}></span></label>
              <input type="text" className={ErrorHelper.renderFieldClasses('booking_landing_page_url', this.props.errors, 'form-control')} name="booking_landing_page_url" value={this.props.booking_landing_page_url || ''} onChange={this.props.onChange} />
            </div>
            {ErrorHelper.renderFieldErrors('booking_landing_page_url', this.props.errors)}
          </div>
        </div>
        {
          this.props.api_key
          ?
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group" style={{marginBottom: 0}}>
                <label>{I18n.t('api_key')}</label>
                <br />
                {this.props.api_key}
              </div>
            </div>
          </div>
          :
          null
        }
      </div>
    )
  }

}